// extracted by mini-css-extract-plugin
module.exports = {"Industry":"industry_Industry__1Ygjk","Title":"industry_Title__gmZq3","ActionBar":"industry_ActionBar__30g8I"};